import { createEntityDescriptor } from '../../redux/entity-descriptor';
import { sortContacts } from './utils';

export const contact = createEntityDescriptor('contact', {
  list: {
    url: '/api/usersForChat.json',
    responseProjection: ({ list }, state) => ({
      list: filterContacts(list, state.auth.username),
    }),
  },
});

export const callHistory = createEntityDescriptor('callHistory', {
  list: {
    url: '/api/callhistory.json',
  },
});

function filterContacts(items, authUsername) {
  return sortContacts(items).filter(item => item.id !== authUsername);
}
